module.exports = __webpack_public_path__ + "static/media/marker.196da6a8.svg";